import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatOutputMonitor } from '../Utils/output_monitor';

export default function OutputMonitoringValue({ monitor }) {
  const { t } = useTranslation();
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  return <span>{formatOutputMonitor(monitor, t, now)}</span>;
}
